"use strict";
/*
 *  Filename........: OrderDataService.ts
 *  Project.........: logistik-app
 *  @copyright......: YBM Deutschland Andy Puderbach und Stephan Wienczny GBR
 *  @version........: 1.0
 *
 *  @since..........: 10.11.20, 12:28
 *  @author.........: robin
 *
 *  @brief..........:
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var DataService_1 = require("@app/services/DataService");
var OrderStatus_1 = __importDefault(require("@app/types/OrderStatus"));
var OrderStatusDataService = /** @class */ (function (_super) {
    __extends(OrderStatusDataService, _super);
    function OrderStatusDataService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return OrderStatusDataService;
}(DataService_1.DataService));
exports.default = new OrderStatusDataService(function (DTO) { return new OrderStatus_1.default(DTO); }, 'orders/status', 2);
